export default {
  data () {
    return {
      barcodeFields: ['barcode_type', 'value'],
      showMoreBarcode: true
    }
  },
  computed: {
    barCodePresent () {
      return this.trainTemplateData.barcodes.length > 0
    },
    multipleBarCode () {
      return this.trainTemplateData.barcodes.length > 1
    },
    showMoreText () {
      return this.showMoreBarcode ? ' >>' : ' <<'
    }
  },
  methods: {
    toggleShowMoreBarcode: function () {
      this.showMoreBarcode = !this.showMoreBarcode
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/barcode.js